import { render, staticRenderFns } from "./DetalleUsuarioGrupos.vue?vue&type=template&id=0c410844&"
import script from "./DetalleUsuarioGrupos.vue?vue&type=script&lang=js&"
export * from "./DetalleUsuarioGrupos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports